module.exports = __webpack_public_path__ + "static/stars-bd4edf2d1072b4163543f749da35c4ee.jpg";